const getters = {
    showLoading: state => state.showLoading,
    breadcrumbItems: state => state.breadcrumbItems
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js